import axios from "axios";
import { authenticatedApiConfig, generateURL } from "./BaseApiService";
export class GlobalAdminBillingService {
    constructor(authenticationProvider, environment) {
        this.authenticationProvider = authenticationProvider;
        this.environment = environment;
    }
    async getBillingDetails(orgId, input) {
        const params = new URLSearchParams();
        params.append("startDate", input.startDate.toISOString());
        params.append("endDate", input.endDate.toISOString());
        if (input.page)
            params.append("page", input.page.toString());
        if (input.pageSize)
            params.append("pageSize", input.pageSize.toString());
        const response = await axios.get(generateURL(this.environment.API_BASE_URL, "/admin/organizations/:orgId/billing/retrieval-queries/details", { orgId }) +
            `?${params.toString()}`, await authenticatedApiConfig(this.authenticationProvider));
        return response.data;
    }
    async getBillingSummary(orgId, input) {
        const params = new URLSearchParams();
        params.append("startDate", input.startDate.toISOString());
        params.append("endDate", input.endDate.toISOString());
        const response = await axios.get(generateURL(this.environment.API_BASE_URL, "/admin/organizations/:orgId/billing/retrieval-queries/summary", { orgId }) +
            `?${params.toString()}`, await authenticatedApiConfig(this.authenticationProvider));
        return response.data;
    }
}
